import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className"];
import React from 'react';
import SVG from "./SVG.js";
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
export * from "./SVG.js";
export default function HeatMap(props) {
  var {
      prefixCls = 'w-heatmap',
      className
    } = props,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [className, prefixCls].filter(Boolean).join(' ');
  return /*#__PURE__*/_jsx(SVG, _extends({
    className: cls
  }, others));
}